// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MobileHeader_wrapper__3LPI7 {
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 30px;
}

.MobileHeader_pill__YnRnY {
  width: 16px;
  height: 16px;
  border-radius: 31px;
  background-color: #cb2d2d;
  font-size: 10px;
  line-height: 12px;
  text-align: center;
  color: #ffffff;
  position: absolute;
  top: -4px;
  right: -1.5px;
  font-family: Inter;
  font-weight: 600;
  letter-spacing: -0.001em;
  justify-content: center;
}

.MobileHeader_notificationBtn__S\\+voo {
  width: 40px;
  height: 40px;
  box-shadow: 3px 4px 16px 0px #7e818c1f;
  border: 1px solid #e2e2e2;
  background-color: white;
  border-radius: 5px;
  transition: background-color 300ms;
}
.MobileHeader_notificationBtn__S\\+voo:hover {
  background-color: #e2e2e2;
  cursor: pointer;
}
.MobileHeader_bell__nmXqY {
  width: 24px;
  height: 24px;
}
.MobileHeader_bellColumn__q6Mpw {
  align-items: flex-end;
  justify-content: flex-start;
  position: relative;
  display: flex;
  flex-direction: column;
}
.MobileHeader_firstCol__diCY\\+,
.MobileHeader_secondCol__xdDfD {
  display: flex;
  align-items: center;
}

.MobileHeader_secondCol__xdDfD {
  gap: 30px;
}

.MobileHeader_imgs__GbNaC {
  height: 30px;
  padding-right: 15px;
}
.MobileHeader_imgs2__qobL5 {
  height: 28px;
}

.MobileHeader_imgs__GbNaC:hover,
.MobileHeader_imgs2__qobL5:hover {
  cursor: pointer;
}

@media screen and (max-width: 600px) {
  .MobileHeader_wrapper__3LPI7 {
    padding: 10px 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/MobileHeader/MobileHeader.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;AACpC;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;AACA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".wrapper {\n  min-height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 30px;\n}\n\n.pill {\n  width: 16px;\n  height: 16px;\n  border-radius: 31px;\n  background-color: #cb2d2d;\n  font-size: 10px;\n  line-height: 12px;\n  text-align: center;\n  color: #ffffff;\n  position: absolute;\n  top: -4px;\n  right: -1.5px;\n  font-family: Inter;\n  font-weight: 600;\n  letter-spacing: -0.001em;\n  justify-content: center;\n}\n\n.notificationBtn {\n  width: 40px;\n  height: 40px;\n  box-shadow: 3px 4px 16px 0px #7e818c1f;\n  border: 1px solid #e2e2e2;\n  background-color: white;\n  border-radius: 5px;\n  transition: background-color 300ms;\n}\n.notificationBtn:hover {\n  background-color: #e2e2e2;\n  cursor: pointer;\n}\n.bell {\n  width: 24px;\n  height: 24px;\n}\n.bellColumn {\n  align-items: flex-end;\n  justify-content: flex-start;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n.firstCol,\n.secondCol {\n  display: flex;\n  align-items: center;\n}\n\n.secondCol {\n  gap: 30px;\n}\n\n.imgs {\n  height: 30px;\n  padding-right: 15px;\n}\n.imgs2 {\n  height: 28px;\n}\n\n.imgs:hover,\n.imgs2:hover {\n  cursor: pointer;\n}\n\n@media screen and (max-width: 600px) {\n  .wrapper {\n    padding: 10px 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `MobileHeader_wrapper__3LPI7`,
	"pill": `MobileHeader_pill__YnRnY`,
	"notificationBtn": `MobileHeader_notificationBtn__S+voo`,
	"bell": `MobileHeader_bell__nmXqY`,
	"bellColumn": `MobileHeader_bellColumn__q6Mpw`,
	"firstCol": `MobileHeader_firstCol__diCY+`,
	"secondCol": `MobileHeader_secondCol__xdDfD`,
	"imgs": `MobileHeader_imgs__GbNaC`,
	"imgs2": `MobileHeader_imgs2__qobL5`
};
export default ___CSS_LOADER_EXPORT___;
